<style lang="stylus">
    .newpage-menu-box
        position fixed
        font-size: 12px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
        z-index: 99;
        background: #fff;
        border-radius 6px
        padding 6px
        &.onlyOne
            >div:not(.delete)
                cursor not-allowed
                opacity 0.4
                filter grayscale(1)
        .newpage-menu-item
            height: 32px;
            min-width 88px
            font-size: 14px;
            position: relative;
            cursor: pointer;
            user-select: none;
            box-sizing: content-box;
            display flex
            align-items center
            white-space nowrap
            color #222
            border-radius 4px
            padding 0 10px
            .icon-suffix
                position absolute
                right 15px
                width 5px
                height 6px
            &:not(.ban):hover
                background: rgba(242, 244, 249, 0.60)
                .vip-icon
                    display block
            img
                margin: 0 12px;
            span
                pointer-events: none;
            .vip-icon
                display none
                width 12px
                height 12px
                margin 0
                margin-left 12px
        .underline
            &:after
                content ''
                position absolute
                left 50%
                bottom 0
                transform translateX(-50%)
                width 83%
                height 1px
                background #0000001A
        .newpage-menu-item.ban
            cursor not-allowed
            color #a0a0a0
    .split-line
        height 1px
        background rgba(0, 0, 0, 0.06)
        margin 4px 10px
        pointer-events none
    .dark-theme__newpagemenu
        background: #2A2C2E
        .newpage-menu-item
            color #e6e6e6
            &:not(.ban):hover
                background rgba(255, 255, 255, 0.08)
</style>

<template>
    <div class="newpage-menu-box" :class="{ 'dark-theme__newpagemenu': isPCDarkMode == 2 }">
        <div
            v-for="(item, index) in menuList"
            :key="item.key || index"
            :id="item.id"
            :title="item.label"
            :class="{
                ban: item.ban,
                underline: item.underline,
                'newpage-menu-item': item.type != 'splitLine',
                'split-line': item.type == 'splitLine',
            }"
            @click="handleClicks(item.key || index, $event)"
            @mouseenter="handleMouseenter(item.key || index, $event)"
            @mouseleave="handleMouseleave(item.key || index, $event)"
        >
            <div v-if="item.type == 'splitLine'"></div>
            <template v-else>
                <span>{{ item.label }}</span>
                <iconSymbol v-if="item.suffixIcon" class="icon-suffix" :name="item.suffixIcon" />
                <img v-if="item.showVip" class="vip-icon" src="@/public/img/vip.svg" alt="" />
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component
    export default class RightMenu extends Vue {
        @Prop({ default: () => [] }) readonly menuList: Array<object>;

        // 在父组件使用原生写法代替事件修饰符，例如 event.stopPropagation()
        handleClicks(flag, e) {
            this.$emit("handleClicks", flag, e);
        }
        handleMouseenter(flag, e) {
            this.$emit("handleMouseenter", flag, e);
        }
        handleMouseleave(flag, e) {
            this.$emit("handleMouseleave", flag, e);
        }
    }
</script>
